<template>
  <div v-if="companyData" class="dsr-config">
    <DgPanel :header="$t('dsr.settings.title')">
      <div class="dsr-config__header">1. {{ $t("dsr.settings.website_info") }}</div>
      <div>
        <form class="dsr-confg__domain" @submit.prevent="onDomainUpdate">
          <DgInput
            :disabled="!$can('view', requiredPermissions)"
            :label="$t('dsr.settings.website_domain')"
            placeholder="This is the placeholder"
            @input="onDomainChange"
            @blur="onDomainChange"
            inputType="submit"
            :value="companyData.domain"
            :class="[
              'dsr-confg__domain-input',
              {
                error: domainError,
              },
            ]"
          />
          <div class="domain-error" v-if="domainError">{{ $t("dsr.settings.invalid_domain_msg") }}</div>
          <div class="domain-success" v-if="updateSuccess">{{ $t("dsr.settings.domain_updated") }}!</div>
          <dg-button
            v-can:edit="requiredPermissions"
            :disabled="domainError"
            :class="['dsr-confg__domain-update', { disabled: domainError }]"
            >{{ $t("dsr.settings.submit_btn") }}
          </dg-button>
        </form>
      </div>
      <div class="dsr-config__header">2. {{ $t("dsr.settings.integration_script") }}</div>
      <div class="dsr-config__container">
        <div class="dsr-config__code">
          <div class="row dsr-confg__domain-input">
            <div class="col-6">
              <DgSelect
                :label="$t('dsr.settings.button_type')"
                placeholder="Select the best option"
                :options="btnOptions"
                initialValue="Dark-l"
                @input="onBtnOptionChange"
                class="dsr-confg__domain-select"
              />
            </div>
            <div class="col-6">
              <DgSelect
                :label="$t('dsr.settings.default_language')"
                :options="languageOptions"
                :initialValue="defaultLang"
                @input="onLangChange"
                :clearable="false"
                class="dsr-confg__domain-select"
              />
            </div>
          </div>
          <DgInput
            :label="$t('dsr.settings.text_on_button')"
            placeholder="This is the placeholder"
            :initialValue="btnText[defaultLang]"
            :value="btnText[defaultLang]"
            @change="onBtnTextChange"
          />
          <div class="dsr-config__header sub">
            {{ $t("dsr.settings.plugin.title") }}
          </div>
          <div class="input-group fake-input-group">
            <DSRCopyContainer :str="containerContent" class="dg-form-input dg-input dg-input-label-row dg-label-row" />
          </div>
        </div>
        <div class="dsr-config__btnpreview">
          <div class="dsr-config__preview">
            <div :class="['btn-wrapper', getBtnClass]">
              <div class="dg-box">
                <div class="dg-btn-text">{{ btnText[defaultLang] }}</div>
              </div>
              <div class="dg-btn__footer">
                <img v-if="btnOption === 0 || btnOption === 3" src="../images/dg_dark.svg" />
                <img v-else src="../images/dg_light.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dsr-config__header">3. {{ $t("dsr.settings.pp.title") }}</div>
      <div class="dsr-config__container">
        <div class="dsr-config__code dsr-config__code--split">
          <div class="dsr-config__header sub">
            {{ $t("dsr.settings.pp.header") }}<br /><br />
            {{ $t("dsr.settings.pp.english_version") }}
          </div>
          <div class="input-group fake-input-group">
            <DSRCopyContainer :str="privacyPolicy.en" class="dg-form-input dg-input dg-input-label-row dg-label-row" />
          </div>
          <div class="dsr-config__header sub">German</div>
          <div class="input-group fake-input-group">
            <DSRCopyContainer :str="privacyPolicy.de" class="dg-form-input dg-input dg-input-label-row dg-label-row" />
          </div>
        </div>
      </div>
    </DgPanel>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Structural, Form, Basic } from "@/dgui-customer-components/";
import DSRCopyContainer from "../components/DSRSettings/DSRCopyContainer.vue";

export default {
  name: "DSR-settings",
  data() {
    return {
      domainError: false,
      updateSuccess: false,
      btnOption: 0,
      domainName: "",
      btnText: {
        en: "Send data subject request",
        de: "Betroffenenanfrage stellen",
      },
      btnOptions: [
        { label: "Dark-l", code: 0 },
        { label: "Light-l", code: 1 },
        { label: "Dark-sm", code: 2 },
        { label: "Light-sm", code: 3 },
      ],
      languageOptions: ["en", "de"],
      defaultLang: "en",
      privacyPolicy: {
        /* eslint-disable prettier/prettier */
        de: `<html><h2>Einsatz vom Data Subject Request Tool (DSR) für das Management von Betroffenenanfragen</h2><h3>1. Umfang der Verarbeitung personenbezogener Daten</h3><p>Wir verwenden Funktionalitäten des Datenschutz-Plugins „DSR“ der DataCo GmbH, Dachauer Str. 65, 80335, München, Bayern, Deutschland (nachfolgend: DataCo genannt).</p><p>Durch eine Nutzung des Buttons „Betroffenenanfrage stellen“ haben alle Besucher unserer Webseite die Möglichkeit von Ihren Betroffenenrechten Gebrauch zu machen. Sie geben dazu Ihre Beziehung zu unserem Unternehmen an, von welchem Betroffenenrecht Sie Gebrauch machen wollen, machen weitere optionale Angaben und identifizieren sich ggf. mit weiteren Merkmalen. Die Betroffenenanfrage wird im Anschluss von uns bearbeitet. </p><p>Es werden dadurch folgende personenbezogene Daten durch DataCo verarbeitet:</p><ul><li>Nachname<li>Vorname<li>Bezug zum Verantwortlichen (Mitarbeiter, Kunde, Interessent, etc.)<li>E-Mail-Adresse<li>Weitere freiwillig kommunizierte personenbezogene Daten</ul><p>Weitere Informationen zur Verarbeitung der Daten durch DataCo erhalten Sie hier: <a href="https://www.dataguard.de/datenschutzerklaerung">https://www.dataguard.de/datenschutzerklaerung</a></p><p>Darüber hinaus können zur Gewährleistung der technischen Funktionalität Logfiles an die DataCo GmbH weitergeleitet werden, die folgendes beinhalten:</p><ul><li>Informationen über den Browsertyp und die verwendete Version<li>Das Betriebssystem des Nutzers<li>Den Internet-Service-Provider des Nutzers<li>Die IP-Adresse des Nutzers<li>Datum und Uhrzeit des Zugriffs<li>Webseiten, von denen das System des Nutzers die Anfrage gestellt hat</ul><h3>2. Zweck der Datenverarbeitung</h3><p>Die Verwendung von DSR dient zur Wahrung der Betroffenenrechte unserer Webseitenbesucher. Wir ermöglichen Ihnen dadurch von Ihren Betroffenenrechten Gebrauch zu machen sowie schnell und einfach mit uns in Kontakt zu treten.</p><h3>3. Rechtsgrundlage für die Verarbeitung personenbezogener Daten</h3><p>Rechtsgrundlage für die Nutzung des DSR-Tools und den Versand entsprechender Daten ist Ihre Einwilligungserklärung nach Art. 6 Abs. 1 S. 1 lit. a DSGVO.</p><p>Rechtsgrundlage für die Nutzung der Logfiles ist unser berechtigtes Interesse der Gewährleistung der technischen Funktionalität des Tools nach Art. 6 Abs. 1 S. 1 lit. f DSGVO.</p><h3>4. Dauer der Speicherung</h3><p>Ihre persönlichen Informationen werden solange gespeichert, wie dies erforderlich ist, um die in dieser Datenschutzerklärung beschriebenen Zwecke zu erfüllen oder wie dies gesetzlich vorgeschrieben ist.</p><h3>5. Widerrufs- und Beseitigungsmöglichkeit</h3><p>Sie können der Erfassung sowie die Verarbeitung Ihrer personenbezogenen Daten widersprechen bzw. Ihre Einwilligungserklärung widerrufen, indem Sie den Verantwortlichen per E-Mail kontaktieren oder das DSR-Tool benutzen. </p></html>`,
        en: `<html><h2>Use of the Data Subject Request Tool (DSR) for the management of data subject requests</h2><h3>1. Scope of processing personal data</h3><p>We use functionalities of the data protection plug-in „DSR“ of DataCo GmbH, Dachauer Str. 65, 80335, Munich, Bavaria, Germany (hereinafter referred to as: DataCo).</p><p>By using the button „Submit Data Subject Request“, all visitors of our website have the opportunity to make use of their data subject rights. To do so, you specify your relationship to our company, which data subject right you wish to exercise, provide further optional information and, if necessary, identify yourself with further characteristics. The data subject request will then be processed by us.</p><p>The following personal data will be processed by DataCo:</p><ul><li>First and last name<li>Relationship to the controller (employee, customer, interested party, etc.)<li>E-mail address<li>Further voluntarily communicated personal data</ul><p>For further information on the processing of data by DataCo, please click here: <a href="https://www.dataguard.com/privacy-policy">https://www.dataguard.com/privacy-policy</a> </p><p>In addition, to ensure technical functionality, logfiles may be forwarded to DataCo GmbH, which include the following:</p><ul><li>Browser type and version used<li>The user’s operation system<li>The user’s internet service provider<li>The user’s IP address<li>Date and time of access<li>Websites from which the user's system made the request</ul><h3>2. Purpose of the data processing</h3><p>The use of DSR serves to protect the data protection rights of our website visitors. We enable you to make use of your data subject rights and to contact us quickly and easily.</p><h3>3. Legal basis for data processing</h3><p>The legal basis for the use of the DSR tool and the processing of corresponding data is your declaration of consent in accordance with art. 6 para. 1 s. 1 lit. a GDPR.</p><p>The legal basis for the use of the logfiles is our legitimate interest in ensuring the technical functionality of the tool according to art. 6 para. 1 s. 1 lit. f GDPR.</p><h3>4. Duration of storage</h3><p>Data will be stored for as long as necessary to fulfil the purposes described in this privacy policy or as required by law.</p><h3>5. Objection and removal</h3><p>The user has the possibility to revoke the consent to the processing of their personal data or object the processing of logfiles at any time by contacting the data controller by mail or by using the DSR tool.</p></html>`,
        /* eslint-disable prettier/prettier */
      },
    };
  },
  components: {
    DgPanel: Structural.DgPanel,
    DgInput: Form.DgInput,
    DgSelect: Form.DgSelect,
    DSRCopyContainer,
  },
  computed: {
    ...mapGetters(["companyData"]),
    containerContent() {
      return `<div id="dg-root" data-option="${this.btnOption}" data-text="${this.btnText[this.defaultLang]
        }" data-id="${this.companyData.token}" data-lang="${this.defaultLang}"></div>
      <script async defer src="https://dataguard.azureedge.net/website/dsr/dist/dsr.min.js"><\/script>`;
    },
    getBtnClass() {
      return `btn-option-${this.btnOption}`;
    },
    requiredPermissions() {
      return ["dsr_settings", "dsr_addon_settings"];
    },
  },
  mounted() {
    this.domainName = this.companyData.domain;
  },
  methods: {
    onBtnTextChange(e) {
      this.btnText[this.defaultLang] = e;
    },
    onBtnOptionChange(e) {
      this.btnOption = e.code;
    },
    isValid(domain) {
      let regexp = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/g;

      return regexp.test(domain);
    },
    onDomainUpdate(e) {
      this.$http
        .put(`/api1/v2/customers/${this.$route.params.id}`, {
          customer: { domain: this.domainName },
        })
        .then(response => {
          let cData = this.companyData;
          cData.domain = this.domainName;
          this.$store.commit("SET_COMPANYDATA", cData);
          this.domainError = false;
          this.updateSuccess = true;
          setTimeout(() => {
            this.updateSuccess = false;
          }, 5000);
        })
        .catch(error => {
          this.apiCatch(error);
        });
    },
    onDomainChange(e) {
      this.domainName = e;
      if (this.isValid(e)) {
        this.domainError = false;
      } else {
        this.domainError = true;
      }
    },
    onLangChange(e) {
      this.defaultLang = e;
    },
  },
};
</script>
<style lang="scss" scoped>
.fake-input-group {
  position: relative;

  .fake-input {
    resize: none;
    border: 1px dashed #9aa7b0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 12px;
    line-height: 24px;
    padding: 9px 64px 9px 14px;
    color: #0b344b;
    width: 100%;
    -webkit-transition: 0.2s all ease;
    transition: 0.2s all ease;
    background: #f1f1f1;
    word-break: break-all;
  }

  .dg-form-input {
    width: 100%;
  }
}

.dsr-config {
  .dsr-confg__domain {
    position: relative;
    display: flex;
    padding-bottom: 10px;
    padding-top: 9px;

    .dsr-confg__domain-input {
      width: 500px;

      input {
        height: 44px;
      }

      &.invalid {
        input {
          border-color: #c63040;
        }
      }
    }

    .dsr-confg__domain-update {
      height: 44px;
      margin-left: 20px;
    }
  }

  .dsr-confg__domain-select {
    margin-bottom: 10px;
  }

  .dsr-config__header {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    color: #9aa7b0;
    padding-bottom: 14px;
    border-bottom: 1px solid #dcdcdc;
    margin-bottom: 20px;

    &.sub {
      font-size: 14px;
      color: #0b344b;
      border: none;
      margin-top: 19px;
      margin-bottom: 5px;
      padding-bottom: 0;
    }
  }

  .dsr-config__container {
    display: flex;

    .dsr-confg__domain-input {
      margin-bottom: 19px;
    }

    .dsr-config__code {
      flex-grow: 1;
      min-width: 0;

      &--split {
        width: calc(100% - 360px);
        flex-grow: 0;
      }
    }

    .dsr-config__btnpreview {
      margin-left: 20px;

      .dsr-config__preview {
        padding: 20px;
        width: 340px;
        background: #f1f1f1;
      }
    }
  }
}

.btn-wrapper {
  font-size: 12px;
  line-height: 24px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell",
    "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  display: flex;
  flex-direction: column;
  color: #ffffff;
  height: 120px;
  border: 1px solid #9aa7b0;
  position: relative;
  overflow: hidden;
}

.dg-btn__footer {
  flex-grow: 1;
  text-align: right;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.dg-btn__footer img {
  width: 92px;
  height: 14px;
  margin: 10px 20px 0 0;
}

.dg-box {
  display: flex;
}

.dg-btn-text {
  background: #0b344b;
  flex-grow: 1;
  font-size: 16px;
  font-weight: 600;
  border-top-left-radius: 10px;
  width: 250px;
  line-height: 24px;
  position: relative;
  padding-left: 63px;
  display: flex;
  align-items: center;
}

.dg-btn-text::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  background-image: url(../images/dsr-icon.svg);
  width: 38px;
  height: 46px;
}

.btn-option-0 .dg-box,
.btn-option-1 .dg-box {
  height: 80px;
  border-bottom: 1px solid #dcdcdc;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn-option-2 .dg-btn-text,
.btn-option-3 .dg-btn-text {
  padding: 10px 20px;
  padding-right: 95px;
  padding-left: 58px;
  text-align: left;
}

.btn-option-2 .dg-btn-text:before,
.btn-option-3 .dg-btn-text:before {
  left: 10px;
  top: 11px;
}

.btn-option-1 .dg-box .dg-btn-text,
.btn-option-3 .dg-box .dg-btn-text {
  background: #ffffff;
  color: #0b344b;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.btn-option-1 .dg-btn__footer,
.btn-option-3 .dg-btn__footer {
  background: #0b344b;
}

.btn-option-2,
.btn-option-2 .dg-box,
.btn-option-3,
.btn-option-3 .dg-box {
  height: 68px;
  overflow: hidden;
}

.btn-option-2 .dg-btn__footer,
.btn-option-3 .dg-btn__footer {
  position: absolute;
  bottom: 10px;
  right: 0px;
  background: none;
}

.btn-option-0 .dg-btn-text:before,
.btn-option-1 .dg-btn-text:before {
  left: 15px;
  top: 17px;
}

.btn-option-2 .dg-btn__footer img,
.btn-option-3 .dg-btn__footer img {
  width: 65px;
  height: 10px;
  margin-right: 10px;
}

.domain-error {
  color: red;
  position: absolute;
  left: 0;
  bottom: 14px;
}

.domain-success {
  color: #72c472;
  margin-top: 16px;
  position: absolute;
  left: 0;
  bottom: 14px;
}
</style>
